export default __webpack_public_path__ + "static/media/11.dca1e8d1.jpg";